module.exports = __webpack_public_path__ + "img/symbol_8.10053be1.png";